<ng-container *transloco="let t; read: 'agencyHeader'">
  <ng-template #content let-offcanvas>
    <div class="offcanvas-header">
      <button type="button" class="btn-close m-0" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="list-inline toolbar-menu">
        @for(menu of menuList; track $index) {
          <li class="py-3">
            <a [routerLink]="menu.url" class="d-flex align-items-center gap-2"
              (click)="offcanvas.dismiss('Cross click')"><img [src]="menu.icon" alt=""
            >
              {{ t(menu.translateKey) }}
            </a>
          </li>
        }
      </ul>
    </div>
  </ng-template>

  <div class="container agency-toolbar pt-4 pb-2">
    <div class="row">
      <div class="col-6 d-flex align-items-center">
        <h1> {{ agencyName }}</h1>
      </div>
      <div class="col-6 d-flex justify-content-end gap-2 pr-0">
        <button class="btn btn-link" (click)="openNotification()">
          <img src="assets/images/notification.svg" alt="Notification">
        </button>
        <!-- <button class="btn btn-link" [routerLink]="['/coming-soon']">
          <img src="assets/images/notification.svg" alt="Notification">
        </button> -->


        <button class="btn btn-link" (click)="openEnd(content)">
          <img src="assets/images/menu.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</ng-container>
